import {
  clampLevel,
  formatLevel,
  formatMeddContactSubtitleDisplay,
} from "../account-relationships/relationshipUtils";

const TIP_ID = "rings-hover-tip";

function getDotBorderColor(rlLevel) {
  if (rlLevel === null || rlLevel === undefined) return "#94a3b8";
  const rl = clampLevel(Math.round(Number(rlLevel)));
  if (rl >= 4) return "#16a34a";
  if (rl >= 2) return "#eab308";
  if (rl >= 1) return "#f59e0b";
  return "#ef4444";
}

function ensureTip() {
  let tip = document.getElementById(TIP_ID);
  if (!tip) {
    tip = document.createElement("div");
    tip.id = TIP_ID;
    tip.className = "rings-hover-tip";
    document.body.appendChild(tip);
  }
  return tip;
}

function appendLine(tip, element) {
  if (tip.childNodes.length > 0) {
    tip.appendChild(document.createElement("br"));
  }
  tip.appendChild(element);
}

function appendTextLine(
  tip,
  text,
  { tag = "span", className = "", color } = {}
) {
  const el = document.createElement(tag);
  if (className) el.className = className;
  if (color) el.style.color = color;
  el.textContent = text;
  appendLine(tip, el);
}

export function showRingsHoverTip(
  event,
  contact,
  { considerMeddpiccRole = false } = {}
) {
  const tip = ensureTip();
  const isMapped = contact?.isMapped !== false;
  const rlInt =
    contact?.rlLevel !== null && contact?.rlLevel !== undefined
      ? clampLevel(Math.round(Number(contact.rlLevel)))
      : null;
  const dotColor = getDotBorderColor(contact?.rlLevel);
  const rlStr = !isMapped
    ? "Not yet mapped"
    : rlInt !== null
      ? formatLevel("RL", rlInt)
      : "RL ? · Unassessed";
  const ctaStr = !isMapped ? "Not yet mapped" : "Click to assess →";
  const rlColor = !isMapped ? "#94a3b8" : dotColor;
  const meddLabel =
    considerMeddpiccRole && contact?.meddRoleLabel
      ? formatMeddContactSubtitleDisplay(contact.meddRoleLabel)
      : "";

  while (tip.firstChild) {
    tip.removeChild(tip.firstChild);
  }

  appendTextLine(tip, contact?.name || "Contact", { tag: "b" });
  appendTextLine(tip, contact?.title || "Customer Contact", {
    className: "rings-hover-tip-muted",
  });
  if (meddLabel) {
    appendTextLine(tip, meddLabel, { className: "rings-hover-tip-role" });
  }
  appendTextLine(tip, rlStr, {
    className: "rings-hover-tip-rl",
    color: rlColor,
  });
  appendTextLine(tip, ctaStr, { className: "rings-hover-tip-cta" });

  tip.style.display = "block";
  moveRingsHoverTip(event);
}

export function moveRingsHoverTip(event) {
  const tip = document.getElementById(TIP_ID);
  if (!tip) return;
  tip.style.left = `${event.clientX + 14}px`;
  tip.style.top = `${event.clientY - 24}px`;
}

export function hideRingsHoverTip() {
  const tip = document.getElementById(TIP_ID);
  if (tip) tip.style.display = "none";
}
